import './App.css';
import './styles/mygamegroup.css';
import SiteNav from './components/partial/SiteNav';
import { useAuthStore } from './stores/useAuthStore';
import NotSignedIn from './components/NotSignedIn';
import MainPage from './components/MainPage';
import Loading from './components/partial/Loading';
import { useFirebaseAuth } from './hooks/useFirebaseAuth';
import AdminGuard from './components/adminGuard';

function App() {
  useFirebaseAuth();

  const isLoading = useAuthStore((state) => state.isAuthLoading);
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);


  return (
    <>
      <div className='container is-fullheight'>

        {isLoading ? <Loading /> : null}

        {!isLoading && !isAuthenticated ? <NotSignedIn /> : null}

        {!isLoading && isAuthenticated ? <>
          <AdminGuard>
            <SiteNav /> <MainPage />
          </AdminGuard>
        </> : null}
      </div>
    </>
  );
}

export default App;
